import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchRemovalOrderUserAllowances,
  fetchRemovalOrderUserEarnings,
  fetchRemovalOrderUserInfos,
} from './fetchRemovalOrderUser'

export enum Field {
  LIQUIDITY_PERCENT = 'LIQUIDITY_PERCENT',
  LIQUIDITY = 'LIQUIDITY',
  CURRENCY_A = 'CURRENCY_A',
  CURRENCY_B = 'CURRENCY_B',
}

export enum ClpField {
  CURRENCY_A = 'CURRENCY_A',
  CURRENCY_B = 'CURRENCY_B',
}

export enum RemovalField {
  TARGET_PRICE_TOKEN_A = 'TARGET_PRICE_TOKEN_A',
  TARGET_PRICE_TOKEN_B = 'TARGET_PRICE_TOKEN_B',
  DELTA_TOKEN_A = 'DELTA_TOKEN_A',
  DELTA_TOKEN_B = 'DELTA_TOKEN_B',
}

export enum RemovalMode {
  SMART,
  RESUBMIT,
  INSTANT,
}

export enum EditingField {
  SMART,
  INSTANT,
}

interface ClpUserDataResponse {
  lpAddress: string
  allowance: string
  stakedBalance: string
  hasRuleEnabled: boolean
  token0Amt: string
  token1Amt: string
  pendingVvs: string
}

export const typeInput = createAction<{ field: Field; typedValue: string }>('burn/typeInputBurn')
export const typeSmartRemovalInput = createAction<{ field: ClpField; typedValue: string }>('burn/typeSmartRemovalInput')
export const snapshotRemovalOrder = createAction<{
  key: string
  info: {
    [RemovalField.TARGET_PRICE_TOKEN_A]: string
    [RemovalField.TARGET_PRICE_TOKEN_B]: string
    [RemovalField.DELTA_TOKEN_A]: number
    [RemovalField.DELTA_TOKEN_B]: number
    inputTokenA: string
    inputTokenB: string
  }
}>('burn/snapshotRemovalOrder')
export const resetBurnState = createAction('burn/resetBurnState')
export const fetchRemovalOrderUserDataAsync = createAsyncThunk<
  ClpUserDataResponse[],
  { account: string; lpAddresses: string[] }
>('burn/fetchClUserAllowance', async ({ account, lpAddresses }) => {
  const userAllowances = await fetchRemovalOrderUserAllowances(account, lpAddresses)
  const userInfos = await fetchRemovalOrderUserInfos(account, lpAddresses)
  const userEarnings = await fetchRemovalOrderUserEarnings(account, lpAddresses)

  return lpAddresses.map((address, i) => {
    const { stakedBalance, hasRuleEnabled, token0Amt, token1Amt } = userInfos[i]
    return {
      lpAddress: address,
      allowance: userAllowances[i],
      stakedBalance,
      hasRuleEnabled,
      token0Amt,
      token1Amt,
      pendingVvs: userEarnings[i],
    }
  })
})
